import { QueryStringIntegerSchema, SortOrder } from 'notable-common';
import { z } from 'zod';
/** The wire format a message arrived in, which decides how it is parsed. */
export var FeedMessageFormat;
(function (FeedMessageFormat) {
    FeedMessageFormat["X12"] = "X12";
    FeedMessageFormat["Hl7"] = "HL7";
    FeedMessageFormat["Json"] = "JSON";
})(FeedMessageFormat || (FeedMessageFormat = {}));
export const FeedMessageFormatSchema = z.enum(FeedMessageFormat);
export var FeedMessageStatus;
(function (FeedMessageStatus) {
    FeedMessageStatus["Success"] = "Success";
    FeedMessageStatus["Filtered"] = "Filtered";
    FeedMessageStatus["Error"] = "Error";
})(FeedMessageStatus || (FeedMessageStatus = {}));
export const FeedMessageStatusSchema = z.enum(FeedMessageStatus);
/** Only `created` is sortable: the list is a time-ordered log of what a feed received. */
export const FeedMessageFindAllQuerySchema = z
    .object({
    messageFormat: FeedMessageFormatSchema.optional(),
    createdAfter: z.coerce.date().optional(),
    createdBefore: z.coerce.date().optional(),
    orderDirection: z.enum(SortOrder).default(SortOrder.Descending),
    orderBy: z.literal('created').default('created'),
    limit: QueryStringIntegerSchema.optional(),
    page: QueryStringIntegerSchema.optional(),
    status: FeedMessageStatusSchema.optional(),
    practiceId: z.uuid().optional(),
    mirthMessageId: QueryStringIntegerSchema.optional(),
    mirthChannelId: z.uuid().optional(),
    source: z.string().min(1).optional(),
})
    .strict();
export const FeedMessageIdParamsSchema = z
    .object({ feedId: z.uuid(), messageId: z.uuid() })
    .strict();
//# sourceMappingURL=message.js.map